// On PDPs, after selecting an option, auto-selects the first available variant with the selected options
// so that we don't end up with nonexistent variants selected, which messes up image selection
{
    function init() {
        document.querySelectorAll('variant-picker').forEach(variantPicker => {
    //    If it's already initialized, return. otherwise, initialize.
    //    This is so that when the section re-renders, it initializes again
          if (variantPicker.dataset.autoSelectInit) {
              return;
          };
          variantPicker.dataset.autoSelectInit = 'true';
          autoSelectNextOptions(variantPicker, 1);
        });
    }

    //get each field of radio buttons
    function getOptionGroups(variantPicker) {
        const radios = variantPicker.querySelectorAll('input[type="radio"][data-option-position]');
        const groups = {};
        //push all radios into an object organized by group (option)
        radios.forEach(radio => {
          const pos = radio.dataset.optionPosition;
          if (!groups[pos]) {
              groups[pos] = [];
          }
          groups[pos].push(radio);
        });
        return Object.values(groups);
    }

    //For a given radio group, get the selected option's label
    function getCheckedLabel(group) {
        const checked = group.find(radio => radio.checked);
        if (!checked) {
            return null;
        }
        return checked.closest('label')?.querySelector('span')?.textContent.trim() ?? null;
    }

    function autoSelectNextOptions(variantPicker, fromIndex) {
        const variantData = JSON.parse(
          variantPicker.querySelector('[data-fullvariants][type="application/json"]')?.textContent || '[]'
        );
        const optionGroups = getOptionGroups(variantPicker);
        const chosenLabels = optionGroups.map(group => getCheckedLabel(group));
        if (chosenLabels.some(label => label === null)) return;

        // Check if the current combination is valid
        const currentVariant = variantData.find(variant =>
          chosenLabels.every((label, i) => variant.options[i] === label)
        );

        if (currentVariant?.available) return; // current selection is fine, do nothing

        // Current selection is unavailable, find the first available from fromIndex onwards
        const lockedLabels = chosenLabels.map((label, i) => i < fromIndex ? label : null);

        for (let i = fromIndex; i < optionGroups.length; i++) {
          const group = optionGroups[i];
          const availableLabel = findFirstAvailableOption(variantData, lockedLabels, i);

          if (availableLabel) {
            const radio = group.find(r =>
              r.closest('label')?.querySelector('span')?.textContent.trim() === availableLabel
            );
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
            lockedLabels[i] = availableLabel;
          } else {
            lockedLabels[i] = getCheckedLabel(group);
          }
        }
    }

    function findFirstAvailableOption(variants, chosenLabels, targetIndex) {
        const matching = variants.filter(variant =>
          chosenLabels.every((label, i) => label === null || variant.options[i] === label)
        );
        const best = matching.find(v => v.available) || matching[0];
        return best ? best.options[targetIndex] : null;
    }

    document.addEventListener('DOMContentLoaded', () => {
        const blockList = document.querySelector('.product-info__block-list');

        if (blockList) {
            //listen for a change event inside the block list -- this means the product options have changed
            blockList.addEventListener('change', (e) => {
                const radio = e.target;
                if (!radio.matches('input[type="radio"][data-option-position]')) return;
                const position = parseInt(radio.dataset.optionPosition);
                const currentPicker = radio.closest('variant-picker');
                if (!currentPicker) return;
                //wait a moment so that it doesn't interfere with Easify's operations
                setTimeout(() => autoSelectNextOptions(currentPicker, position), 50);
            });

            //this mutationobserver listens for when Shopify reloads the variant picker so that auto-select is re-initialized
            new MutationObserver(() => {
                init();
            }).observe(blockList, { childList: true, subtree: false });
        }

        init();
    });
}